"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forms = void 0;
var kea_1 = require("kea");
var utils_1 = require("./utils");
function forms(input) {
    var _this = this;
    return function (logic) {
        var forms = typeof input === 'function' ? input(logic) : input;
        var _loop_1 = function (formKey, formInput) {
            var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var _o = formInput.options || {}, showErrorsOnTouch = _o.showErrorsOnTouch, alwaysShowErrors = _o.alwaysShowErrors;
            var capitalizedFormKey = (0, utils_1.capitalizeFirstLetter)(formKey);
            (0, kea_1.actions)((_c = {},
                _c["set".concat(capitalizedFormKey, "Value")] = function (name, value) { return ({ name: name, value: value }); },
                _c["set".concat(capitalizedFormKey, "Values")] = function (values) { return ({ values: values }); },
                _c["set".concat(capitalizedFormKey, "ManualErrors")] = function (errors) { return ({ errors: errors }); },
                _c["touch".concat(capitalizedFormKey, "Field")] = function (key) { return ({ key: key }); },
                _c["reset".concat(capitalizedFormKey)] = function (values) { return ({ values: values }); },
                _c["submit".concat(capitalizedFormKey)] = true,
                _c["submit".concat(capitalizedFormKey, "Request")] = function (formValues) {
                    var _a;
                    return (_a = {}, _a[formKey] = formValues, _a);
                },
                _c["submit".concat(capitalizedFormKey, "Success")] = function (formValues) {
                    var _a;
                    return (_a = {}, _a[formKey] = formValues, _a);
                },
                _c["submit".concat(capitalizedFormKey, "Failure")] = function (error, errors) { return ({ error: error, errors: errors }); },
                _c))(logic);
            if (formInput.defaults) {
                (0, kea_1.defaults)((_d = {},
                    _d[formKey] = formInput.defaults,
                    _d))(logic);
            }
            (0, kea_1.reducers)((_e = {},
                _e[formKey] = (_f = {},
                    _f["set".concat(capitalizedFormKey, "Value")] = function (state, _a) {
                        var name = _a.name, value = _a.value;
                        return (0, utils_1.deepAssign)(state, name, value);
                    },
                    _f["set".concat(capitalizedFormKey, "Values")] = function (state, _a) {
                        var values = _a.values;
                        return (__assign(__assign({}, state), values));
                    },
                    _f["reset".concat(capitalizedFormKey)] = function (state, _a) {
                        var values = _a.values;
                        return values || formInput.defaults || {};
                    },
                    _f),
                _e["is".concat(capitalizedFormKey, "Submitting")] = [
                    false,
                    (_g = {},
                        _g["reset".concat(capitalizedFormKey)] = function () { return false; },
                        _g["submit".concat(capitalizedFormKey, "Request")] = function () { return true; },
                        _g["submit".concat(capitalizedFormKey, "Success")] = function () { return false; },
                        _g["submit".concat(capitalizedFormKey, "Failure")] = function () { return false; },
                        _g),
                ],
                _e["show".concat(capitalizedFormKey, "Errors")] = [
                    false,
                    (_h = {},
                        _h["reset".concat(capitalizedFormKey)] = function () { return false; },
                        _h["set".concat(capitalizedFormKey, "ManualErrors")] = function () { return true; },
                        _h["submit".concat(capitalizedFormKey)] = function () { return true; },
                        _h["submit".concat(capitalizedFormKey, "Success")] = function () { return false; },
                        _h["submit".concat(capitalizedFormKey, "Failure")] = function () { return true; },
                        _h),
                ],
                _e["".concat(formKey, "Changed")] = [
                    false,
                    (_j = {},
                        _j["reset".concat(capitalizedFormKey)] = function () { return false; },
                        _j["set".concat(capitalizedFormKey, "Value")] = function () { return true; },
                        _j["set".concat(capitalizedFormKey, "Values")] = function () { return true; },
                        _j),
                ],
                _e["".concat(formKey, "Touches")] = [
                    {},
                    (_k = {},
                        _k["reset".concat(capitalizedFormKey)] = function () { return ({}); },
                        _k["touch".concat(capitalizedFormKey, "Field")] = function (state, _a) {
                            var _b;
                            var key = _a.key;
                            return key in state ? state : __assign(__assign({}, state), (_b = {}, _b[key] = true, _b));
                        },
                        _k),
                ],
                _e["".concat(formKey, "ManualErrors")] = [
                    {},
                    (_l = {},
                        _l["reset".concat(capitalizedFormKey)] = function () { return ({}); },
                        _l["set".concat(capitalizedFormKey, "ManualErrors")] = function (_, _a) {
                            var errors = _a.errors;
                            return errors;
                        },
                        _l["touch".concat(capitalizedFormKey, "Field")] = function (state, _a) {
                            var key = _a.key;
                            if (key in state) {
                                var _b = state, _c = key, _discard = _b[_c], rest = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
                                return rest;
                            }
                            return state;
                        },
                        _l),
                ],
                _e))(logic);
            (0, kea_1.selectors)((_m = {},
                _m["".concat(formKey, "Touched")] = [
                    function (s) { return [s["".concat(formKey, "Touches")]]; },
                    function (touches) { return Object.keys(touches).length > 0; },
                ],
                _m["".concat(formKey, "ValidationErrors")] = Array.isArray(formInput.errors)
                    ? formInput.errors
                    : [function (s) { return [s[formKey]]; }, formInput.errors || (function () { return ({}); })],
                _m["".concat(formKey, "AllErrors")] = [
                    function (s) { return [s["".concat(formKey, "ValidationErrors")], s["".concat(formKey, "ManualErrors")]]; },
                    function (validationErrors, manualErrors) { return (__assign(__assign({}, validationErrors), manualErrors)); },
                ],
                _m["".concat(formKey, "HasErrors")] = [
                    function (s) { return [s["".concat(formKey, "AllErrors")]]; },
                    function (allErrors) { return (0, utils_1.deepTruthy)(allErrors); },
                ],
                _m["".concat(formKey, "Errors")] = [
                    function (s) { return [s["".concat(formKey, "AllErrors")], s["show".concat(capitalizedFormKey, "Errors")], s["".concat(formKey, "Touches")]]; },
                    function (allErrors, showErrors, touches) {
                        return alwaysShowErrors || showErrors ? allErrors : showErrorsOnTouch ? (0, utils_1.getTouchErrors)(allErrors, touches) : {};
                    },
                ],
                _m["is".concat(capitalizedFormKey, "Valid")] = [
                    function (s) { return [s["".concat(formKey, "ValidationErrors")]]; },
                    function (errors) { return !(0, utils_1.hasErrors)(errors); },
                ],
                _m))(logic);
            (0, kea_1.listeners)(function (_a) {
                var _b;
                var actions = _a.actions, values = _a.values;
                return (_b = {},
                    _b["submit".concat(capitalizedFormKey)] = function (_, breakpoint) { return __awaiter(_this, void 0, void 0, function () {
                        var canSubmit;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    if (!formInput.preSubmit) return [3, 2];
                                    return [4, ((_a = formInput.preSubmit) === null || _a === void 0 ? void 0 : _a.call(formInput, values[formKey], breakpoint))];
                                case 1:
                                    _c.sent();
                                    _c.label = 2;
                                case 2:
                                    canSubmit = !values["".concat(formKey, "HasErrors")] || ((_b = formInput.options) === null || _b === void 0 ? void 0 : _b.canSubmitWithErrors);
                                    if (canSubmit) {
                                        actions["submit".concat(capitalizedFormKey, "Request")](values[formKey]);
                                    }
                                    else {
                                        actions["submit".concat(capitalizedFormKey, "Failure")](new Error('Validation Failed'), values.allErrors);
                                    }
                                    return [2];
                            }
                        });
                    }); },
                    _b["submit".concat(capitalizedFormKey, "Request")] = function (_a, breakpoint) {
                        var _b = formKey, formValues = _a[_b];
                        return __awaiter(_this, void 0, void 0, function () {
                            var newValues, error_1;
                            var _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        _d.trys.push([0, 2, , 3]);
                                        return [4, ((_c = formInput.submit) === null || _c === void 0 ? void 0 : _c.call(formInput, formValues, breakpoint))];
                                    case 1:
                                        newValues = _d.sent();
                                        actions["submit".concat(capitalizedFormKey, "Success")](typeof newValues !== 'undefined' ? newValues : formValues);
                                        return [3, 3];
                                    case 2:
                                        error_1 = _d.sent();
                                        if (!(0, kea_1.isBreakpoint)(error_1)) {
                                            actions["submit".concat(capitalizedFormKey, "Failure")](error_1, values.allErrors);
                                        }
                                        return [3, 3];
                                    case 3: return [2];
                                }
                            });
                        });
                    },
                    _b);
            })(logic);
        };
        for (var _i = 0, _a = Object.entries(forms); _i < _a.length; _i++) {
            var _b = _a[_i], formKey = _b[0], formInput = _b[1];
            _loop_1(formKey, formInput);
        }
    };
}
exports.forms = forms;
//# sourceMappingURL=builder.js.map